import Intercom from '@intercom/messenger-js-sdk';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { FC, ReactNode, useEffect, useMemo } from 'react';
import { ToastContainer } from 'react-toastify';

import { useGtmConsent } from './hooks/use-gtm-consent.hook';

interface AppProps {
  children: ReactNode;
}

const App: FC<AppProps> = ({ children }) => {
  const queryClient = useMemo(() => new QueryClient(), []);

  useGtmConsent();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    if (/ReactSnap/i.test(navigator.userAgent)) {
      return;
    }

    const start = () => {
      Intercom({
        app_id: process.env.REACT_APP_INTERCOM_ID || '',
      });
    };

    const idle = (
      window as {
        requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
      } & typeof window
    ).requestIdleCallback;

    if (idle) {
      idle(start, { timeout: 4000 });
      return;
    }

    const timer = window.setTimeout(start, 3500);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App overflow-y-scroll" id="scrollable-target">
        {children}
      </div>
      <ToastContainer closeOnClick position="bottom-center" />
    </QueryClientProvider>
  );
};

export default App;
